import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------brand-listing--------------------------
export const brandListApi = async (data) => {
    const endPoint =
        `brand/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
};
// -------------------------addBrand ----------------------------
export const addBrandApi = async (data) => {
    const endPoint = `brand/add`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};

// ------------------------Edit brand------------------
export const editBrandApi = async (data) => {
    const endPoint = `brand/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
export const brandDeleteApi = async (id) => {
    const endPoint = `brand/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};
export const changeStatusBrandApi = async (data) => {
    const endPoint = `brand/status`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};





